import { useState } from 'react';

function Footer() {
    return (
        <div>
            <section className='Footer'>
                <p className='FooterName'>TAK STUDIO</p>
                <div className='Pages'>
                    <a className='FooterLinks' href='/work'>
                        Work
                    </a>
                    <a className='FooterLinks' href='/services'>
                        Services
                    </a>
                    <a className='FooterLinks' href='/about'>
                        About
                    </a>
                    <a className='FooterLinks' href='/contact'>
                        Contact
                    </a>
                </div>
                <div className='SocialMedia'>
                    <a className='FooterLinks' href='https://www.instagram.com/takstudio.de?igsh=cDdoNG5pc3J5dmsy'>
                        Instagram
                    </a>
                    <a className='FooterLinks'>
                        LinkedIn
                    </a>
                    <a className='FooterLinks'>
                        Dribbble
                    </a>
                </div>
            </section>
            <section className='ARR'>
                <div className='ARRWrapper'>
                    <p className='Credits'>
                        © 2026 TAK STUDIO
                    </p>
                    <p className='TypicalARR'>
                        All rights reserved.
                    </p>
                </div>
            </section>
        </div>
    );
}

export default Footer;